import { useMemo } from 'react';
import { useEntityEntitlements } from './useEntityEntitlements';
import type { EntityEntitlementsResponse } from '../types/EntityEntitlements';

interface DashboardCounts {
    counts: Map<string, number>;
    loading: boolean;
    fetchCounts: (entityTypes: string[]) => void;
}

function buildCountsFromEntitlements(payload: EntityEntitlementsResponse | null): Map<string, number> {
    const map = new Map<string, number>();
    if (!payload?.EntityEntitlements) return map;

    for (const item of payload.EntityEntitlements) {
        if (item.Count != null) {
            map.set(item.Id, item.Count);
        }
    }

    if (payload.EntitySets) {
        for (const [setName, memberTypes] of Object.entries(payload.EntitySets)) {
            if (!map.has(setName) && Array.isArray(memberTypes)) {
                let sum = 0;
                let hasAny = false;
                for (const memberId of memberTypes) {
                    const memberCount = map.get(memberId);
                    if (memberCount != null) {
                        sum += memberCount;
                        hasAny = true;
                    }
                }
                if (hasAny) {
                    map.set(setName, sum);
                }
            }
        }
    }

    return map;
}

const NOOP = () => {};

export const useDashboardCounts = (): DashboardCounts => {
    const { entityEntitlements, loading: entitlementsLoading } = useEntityEntitlements();

    const counts = useMemo(
        () => buildCountsFromEntitlements(entityEntitlements),
        [entityEntitlements]
    );

    return { counts, loading: entitlementsLoading, fetchCounts: NOOP };
};
